export const BOGO = 'bogo';
export const MSB = 'msb';
export const BMSM = 'bmsm';

export const EXPERIENCE_TAGS = {
  BOGO: 'BOGO',
  MSB: 'MSBONLINE',
  BMSM: 'BMSM',
};

export const MAX_NUM_TIERS_IN_PROMOTION = 5;
export const MULTI_SELECT_QUANTITY = 1;

export const MA = 'MAJOR_APPLIANCE';
export const GM = 'MERCHANDISE';
export const NVALUE_REFINEMENT_SEPARATOR = 'Z';
export const BACKWARDS_BOGO_SUBEXPERIENCES = [
  'buyOneGetOneBackwards', 'buyOneGetPercentageOffBackwards', 'buyOneGetDollarOffBackwards'
];
